import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "../Home";
import Categoria from "../Categoria";
import Marcas from "../Marcas";
import Produtos from "../Produtos";
import Login from "../Login";
import Admin from "../Admin";
import { AuthProvider } from "../context/AuthContext";
import PrivateRoute from "../Components/PrivateRoute";

const Rotas = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* Login público */}
          <Route path="/" element={<Home />} />

          {/* Catálogo (cliente) */}
          <Route
            path="/home"
            element={
              <PrivateRoute tipoPermitido="cliente">
                <Home />
              </PrivateRoute>
            }
          />
          <Route
            path="/categorias"
            element={
              <PrivateRoute tipoPermitido="cliente">
                <Categoria />
              </PrivateRoute>
            }
          />
          <Route
            path="/categorias/:subgrupo"
            element={
              <PrivateRoute tipoPermitido="cliente">
                <Marcas />
              </PrivateRoute>
            }
          />
          <Route
            path="/categorias/:subgrupo/:marca"
            element={
              <PrivateRoute tipoPermitido="cliente">
                <Produtos />
              </PrivateRoute>
            }
          />

          {/* Login Admin */}
          <Route path="/admin" element={<Login />} />

          {/* Painel Admin */}
          <Route
            path="/dashboard"
            element={
              <PrivateRoute tipoPermitido="admin">
                <Admin />
              </PrivateRoute>
            }
          />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default Rotas;
